import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Baseline Data Collection Framework',
      type: 'report-card',
      content: {
        '[]': [
          {
            '{}': {
              name: 'Section A: Organizational Profile',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Girls Served',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'girlsServed',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Current Revenue',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'assessments',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'currentRevenue',
                                      ],
                                    },
                                  ],
                                },
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Staff Count',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'staffCount',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Board Size',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'boardSize',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Service Region',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'affiliates',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'serviceRegion',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Years in Operation',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'affiliates',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'yearsInOperation',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Section B: Revenue Portfolio Analysis',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Individual Giving',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '@': 'revenueIndividualGiving',
                                },
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Major Gifts',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '@': 'revenueMajorGifts',
                                },
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Foundation Grants',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '@': 'revenueFoundationGrants',
                                },
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Corporate Partnerships',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '@': 'revenueIndividualGiving',
                                },
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Special Events',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '@': 'revenuSpecialEvents',
                                },
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Government Funding',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '@': 'revenueGovernmentFunding',
                                },
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Other Revenue',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '@': 'revenueOtherRevenue',
                                },
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Section C: Donor Portfolio Metrics',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Total Active Donors',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'totalActiveDonors',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'New Donors (Annual)',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'newDonors',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Retained Donors',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'retainedDonors',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Lapsed Donors',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'lapsedDonors',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Donor Lifetime Value',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'assessments',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'donorLifetimeValue',
                                      ],
                                    },
                                  ],
                                },
                              },
                              '$',
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Giving Frequency',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'givingFrequency',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Online vs. Offline',
                      value: {
                        '{}': {
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'assessments',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'onlineSplit',
                                      ],
                                    },
                                  ],
                                },
                              },
                              '%',
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    orgRecordId: '?1',
  },
  subqueries: {
    affiliates: {
      filter: {
        '=': [
          {
            '@$': 'orgRecordId',
          },
          {
            '@.': '!id',
          },
        ],
      },
      target: 'ent:!org:!affiliate',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          serviceRegion: {
            '@.': '!service_region',
          },
          yearsInOperation: {
            '@.': '!years_in_operation',
          },
        },
      },
    },
    assessments: {
      ref: {
        attr: 'attr:ent#!assessments#!asssessment:!affiliate',
      },
      filter: {
        '=': [
          {
            '@.': [
              '!affiliate',
              {
                ref: {
                  entity: '!affiliate',
                },
              },
            ],
          },
          {
            '@$': 'orgRecordId',
          },
        ],
      },
      target: 'ent:!assessments:!assessment',
      selection: {
        '{}': {
          affiliate: {
            '@.': '!affiliate',
          },
          boardSize: {
            '@.': '!board_size',
          },
          newDonors: {
            '@.': '!new_donors',
          },
          staffCount: {
            '@.': '!staff_count',
          },
          girlsServed: {
            '@.': '!girls_served',
          },
          onlineSplit: {
            '@.': '!online_split',
          },
          grantWriting: {
            '@.': '!grant_writing',
          },
          lapsedDonors: {
            '@.': '!lapsed_donors',
          },
          caseForSupport: {
            '@.': '!case_for_support',
          },
          currentRevenue: {
            '@.': '!current_revenue',
          },
          retainedDonors: {
            '@.': '!retained_donors',
          },
          boardEngagement: {
            '@.': '!board_engagement',
          },
          digitalPresence: {
            '@.': '!digital_presence',
          },
          eventManagement: {
            '@.': '!event_management',
          },
          givingFrequency: {
            '@.': '!giving_frequency',
          },
          totalActiveDonors: {
            '@.': '!total_active_donors',
          },
          dataAnalyticsUsage: {
            '@.': '!data_analytics_usage',
          },
          donorLifetimeValue: {
            '@.': '!donor_lifetime_value',
          },
          marketingMaterials: {
            '@.': '!marketing_materials',
          },
          majorGiftExperience: {
            '@.': '!major_gift_experience',
          },
          stewardshipPrograms: {
            '@.': '!stewardship_programs',
          },
          donorDatabaseManagement: {
            '@.': '!donor_database_management',
          },
        },
      },
    },
    revenueMajorGifts: {
      ref: {
        attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
      },
      filter: {
        and: [
          {
            '=': [
              {
                '@.': [
                  '!affiliate',
                  {
                    ref: {
                      entity: '!affiliate',
                    },
                  },
                ],
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': [
                  '!func_fs',
                  {
                    ref: {
                      entity: '!func',
                    },
                  },
                ],
              },
              '?2',
            ],
          },
        ],
      },
      target: 'ent:!fs_entries:!fs_entry',
      selection: {
        '@.': '!amount',
      },
    },
    revenuSpecialEvents: {
      ref: {
        attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
      },
      filter: {
        and: [
          {
            '=': [
              {
                '@.': [
                  '!affiliate',
                  {
                    ref: {
                      entity: '!affiliate',
                    },
                  },
                ],
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': [
                  '!func_fs',
                  {
                    ref: {
                      entity: '!func',
                    },
                  },
                ],
              },
              '?7',
            ],
          },
        ],
      },
      target: 'ent:!fs_entries:!fs_entry',
      selection: {
        '@.': '!amount',
      },
    },
    revenueOtherRevenue: {
      ref: {
        attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
      },
      filter: {
        and: [
          {
            '=': [
              {
                '@.': [
                  '!affiliate',
                  {
                    ref: {
                      entity: '!affiliate',
                    },
                  },
                ],
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': [
                  '!func_fs',
                  {
                    ref: {
                      entity: '!func',
                    },
                  },
                ],
              },
              '?1',
            ],
          },
        ],
      },
      target: 'ent:!fs_entries:!fs_entry',
      selection: {
        '@.': '!amount',
      },
    },
    revenueFoundationGrants: {
      ref: {
        attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
      },
      filter: {
        and: [
          {
            '=': [
              {
                '@.': [
                  '!affiliate',
                  {
                    ref: {
                      entity: '!affiliate',
                    },
                  },
                ],
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': [
                  '!func_fs',
                  {
                    ref: {
                      entity: '!func',
                    },
                  },
                ],
              },
              '?5',
            ],
          },
        ],
      },
      target: 'ent:!fs_entries:!fs_entry',
      selection: {
        '@.': '!amount',
      },
    },
    revenueIndividualGiving: {
      ref: {
        attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
      },
      filter: {
        and: [
          {
            '=': [
              {
                '@.': [
                  '!affiliate',
                  {
                    ref: {
                      entity: '!affiliate',
                    },
                  },
                ],
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': [
                  '!func_fs',
                  {
                    ref: {
                      entity: '!func',
                    },
                  },
                ],
              },
              '?3',
            ],
          },
        ],
      },
      target: 'ent:!fs_entries:!fs_entry',
      selection: {
        '@.': '!amount',
      },
    },
    revenueGovernmentFunding: {
      ref: {
        attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
      },
      filter: {
        and: [
          {
            '=': [
              {
                '@.': [
                  '!affiliate',
                  {
                    ref: {
                      entity: '!affiliate',
                    },
                  },
                ],
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': [
                  '!func_fs',
                  {
                    ref: {
                      entity: '!func',
                    },
                  },
                ],
              },
              '?4',
            ],
          },
        ],
      },
      target: 'ent:!fs_entries:!fs_entry',
      selection: {
        '@.': '!amount',
      },
    },
    revenueCorporateSponsorships: {
      ref: {
        attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
      },
      filter: {
        and: [
          {
            '=': [
              {
                '@.': [
                  '!affiliate',
                  {
                    ref: {
                      entity: '!affiliate',
                    },
                  },
                ],
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': [
                  '!func_fs',
                  {
                    ref: {
                      entity: '!func',
                    },
                  },
                ],
              },
              '?6',
            ],
          },
        ],
      },
      target: 'ent:!fs_entries:!fs_entry',
      selection: {
        '@.': '!amount',
      },
    },
  },
}
